module.exports = __webpack_public_path__ + "img/multiple.c1e11c63.jpg";